<template>
  <div style="display: flex">
    <div v-if="!loading" class="slp-button" @click="loading=true,loginWithSLP()">
      <div class="slp-button__icon">
        <img src="../../../assets/slpIcon.png" alt="">
      </div>
      <div class="slp-button__text">
        <slot>スマートライフパスでログイン</slot>
      </div>
    </div>
    <div v-else class="slp-button">
      <div class="slp-button__icon">
        <img src="../../../assets/slpIcon.png" alt="">
      </div>
      <div class="slp-button__text">
        <slot>スマートライフパスでログイン</slot>
        <v-progress-circular
          indeterminate
          color="white"
          size="25"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  data: () => ({
    state: '',
    loading: false,
  }),
  methods: {
    async getUrl() {
      localStorage.removeItem("pathBeforeSignup")
      localStorage.setItem('pathBeforeSLP', this.$route.path)
      // CloudFunctionsのslpLoginStartを、https on callで呼び出す
      const redirect_uri = `${window.location.origin}/slp_callback`;
      const functions = firebase.functions();
      const slpLoginStart = functions.httpsCallable("slpLoginStart");
      const { data } = await slpLoginStart({ redirect_uri });
      const { authorizationUrl, state, nonce } = data;
      // nonceをキーにstateをsessionStorageに保存
      // TODO: 既にslp:から始まる値があれば削除することを検討
      localStorage.setItem(`slp:${state}`, nonce);
      return authorizationUrl;
    },
    async loginWithSLP() {
      const authorizationUrl = await this.getUrl();
      window.location.href = authorizationUrl;
    },
  },
}
</script>
<style scoped>
.slp-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 100%;
    margin: 0 auto;
    cursor: pointer;
    border-radius: 9999px;
    position:relative;
    z-index:1;
    background:linear-gradient(to bottom, #048132, #93C546);
    text-align:center;
}
.slp-button::before {
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    box-sizing:border-box;
    border-radius:2em;
    padding:2px;
    width:100%;
    height:100%;
    background:#fff;
    background-clip:content-box;
    content:"";
}
.slp-button__icon {
    margin: 0 0px 0 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.slp-button__icon img {
    width: 40px;
    height: 40px;
}
.slp-button__text {
    font-size: 1rem;
    height: 50%;
    font-weight: normal;
    color: #048132;
    margin: 0 20px 0 10px;
}
@media screen and (max-width:599px) {
  .slp-button__text {
    font-size: 0.8rem;
    margin: 0 20px 0 10px;
  }
}
</style>
